import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';

import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as QRCode from 'qrcode';

import { GerinusService } from '../lib/gerinus.service';

import { interRegular } from '../../../assets/fonts/inter/Inter-Regular-normal';
import { interSemiBold } from '../../../assets/fonts/inter/Inter-SemiBold-normal';

import { ICancelRequestSchema, IChangeRequestDescriptionSchema, Request } from 'src/app/interfaces/request';
import { RequestStatusEnum } from 'src/app/Enums/RequestStatusEnum';

import { environment } from 'src/environments/environment';
import { IStepOption } from 'src/app/interfaces/stepOption';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ISendFileProcessPdf } from 'src/app/interfaces/processCommon.interface';
import { requestGeneratesDocumentsName } from 'src/app/Enums/commonProcessEnum';
import { OrganizationEnum } from 'src/app/Enums/organizationEnum';
import { GlobalService } from '../lib/global.service';
import { UserService } from './user.service';
import { ICitizenOverview, IServiceCatalogResponse } from 'src/app/interfaces/request-ui';

export interface IStepsFormRequest {
    requestData: IStepOption,
    forms: IStepOption,
    attachment: IStepOption,
    summary: IStepOption
}

@Injectable()
export class RequestService extends GerinusService {

    constructor(
        public http: HttpClient,
        private datePipe: DatePipe,
        public global: GlobalService,
        public userService: UserService,
    ) {
        super(http);
        this.entityName = 'solicitacao';
        this.idField = 'SOL_CodigoSolicitacao';
        this.model = 'SolicitacaoModel';
    }

    public get organizationIsSemurb() {
        return this.global.user().OR_NumeroOrgao == OrganizationEnum.SEMURB && !this.userService.isCidadao();
    }

    public async generateFullRequestPDF(request: Request, hideCpf = false) {
        const hideCpfIn = (text: string) => hideCpf ? this.maskCpf(text) : text;
        const doc = new jsPDF('p', 'mm', 'a4');
        const pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

        const logoProtocolize = new Image();
        const urlPublicRequest = environment.projectURL + '/free/solicitacao/' + request.SOL_CodigoSolicitacao;
        const qrcodeImage = await QRCode.toDataURL(urlPublicRequest);
        let qrcode: string;

        QRCode.toDataURL(urlPublicRequest, (_, url) => {
            var base64Data = url.split(',')[1];
            qrcode = atob(base64Data);
        });

        logoProtocolize.src = '../../assets/img/brand/logo-protocolizesga.png';
        doc.addImage(logoProtocolize, 'png', 57, 5, 95, 18);

        doc.addFileToVFS('Inter-Bold.ttf', interSemiBold);
        doc.addFont('Inter-Bold.ttf', 'Inter-Bold', 'normal');
        doc.setFont('Inter-SemiBold');

        doc.addFileToVFS('Inter-Regular.ttf', interRegular);
        doc.addFont('Inter-Regular.ttf', 'Inter-Regular', 'normal');

        doc.setFont('Inter-SemiBold');
        doc.setFontSize(16);
        doc.setTextColor('#0A2156');
        doc.text((request.SOLR_TipoOrgaoFiscalizador ? 'Protocolo N° ' : 'Solicitação N° ') + request.SOL_NumeroSolicitacao + '/' + request.SOL_AnoSolicitacao, 103, 35, { align: 'center' });

        const requestDateFormatted = this.datePipe.transform(request.SOL_DataSolicitacao, 'dd/MM/yyyy');

        doc.setFont('Inter-Regular');
        doc.setFontSize(12);
        doc.setTextColor('#687489');
        doc.text('Data da solicitação: ' + requestDateFormatted, 103, 42, {
            align: 'center',
        });

        const renderHeader = () => {
            const logoProtocolize = new Image();
            logoProtocolize.src = '../../assets/img/brand/logo-protocolizesga.png';
            doc.addImage(logoProtocolize, 'png', 60, 5, 95, 18);

            doc.addFileToVFS('Inter-Bold.ttf', interSemiBold);
            doc.addFont('Inter-Bold.ttf', 'Inter-Bold', 'normal');
            doc.setFont('Inter-SemiBold');

            doc.addFileToVFS('Inter-Regular.ttf', interRegular);
            doc.addFont('Inter-Regular.ttf', 'Inter-Regular', 'normal');

            doc.setFontSize(12);
            doc.setTextColor('#0A2156');
            doc.text('Sistema de Protocolo e Tramitação Eletrônica', pageWidth / 2, 30, {
                align: 'center',
            });
        };
        const pageHeight = doc.internal.pageSize.getHeight();

        const renderFooter = (qrcodeImage: string) => {
            autoTable(doc, {
                body: [
                    [
                        {
                            content: 'Situação:',
                            styles: {
                                halign: 'center',
                                valign: 'middle',
                                font: 'Inter-SemiBold',
                                cellWidth: 30,
                                fontSize: 12,
                                cellPadding: {
                                    bottom: 0,
                                    top: 0,
                                    right: 0,
                                    left: 0,
                                },
                                textColor: '#0A2156',
                            },
                        },
                        {
                            content: this.getStatusDescription(request.SOL_Status),
                            styles: {
                                halign: 'left',
                                fontSize: 12,
                                cellPadding: 3,
                                textColor: '#687489',
                            },
                        },
                        {
                            content: '',
                            rowSpan: 2,
                            styles: {
                                halign: 'center',
                                valign: 'middle',
                                fontSize: 12,
                                cellPadding: 6,
                                textColor: '#687489',
                            },
                        },
                    ],
                    [
                        {
                            content: 'Chave de verificação:',
                            styles: {
                                halign: 'center',
                                valign: 'middle',
                                font: 'Inter-SemiBold',
                                cellWidth: 50,
                                fontSize: 12,
                                cellPadding: {
                                    bottom: 0,
                                    top: 0,
                                    right: 0,
                                    left: 0,
                                },
                                textColor: '#0A2156',
                            },
                        },
                        {
                            content: request.SOL_ChaveAutenticidade,
                            styles: {
                                halign: 'left',
                                fontSize: 12,
                                cellPadding: 3,
                                textColor: '#687489',
                            },
                        },
                    ],
                    [
                        {
                            content:
                                'Acompanhe sua solicitação acessando https://web.protocolize.pmsga.ce.gov.br/principal ou aponte a câmera do seu celular para o QR Code ao lado.',
                            colSpan: 3,
                            styles: {
                                halign: 'left',
                                fontSize: 12,
                                cellPadding: 3,
                                textColor: '#687489',
                            },
                        },
                    ],
                ],
                
                theme: 'plain',
                startY: pageHeight - 68,
                styles: {
                    lineWidth: 0.2,
                    lineColor: '#687489',
                    font: 'Inter-Regular',
                },
                didDrawCell: (data) => {
                    if (
                        qrcodeImage &&
                        data.column.index === 2 &&
                        data.row.index === 0 &&
                        data.cell.rowSpan === 2
                    ) {
                        const padding = 2;
                        const qrSize = 20;
        
                        const x = data.cell.x + data.cell.width / 2 - qrSize / 2;
                        const y = data.cell.y + data.cell.height / 2 - qrSize / 2;
        
                        doc.addImage(qrcodeImage, 'PNG', x, y, qrSize, qrSize);
                    }
                },
            });
        }


        const addNewPage = (title: string) => {
            doc.addPage();

            doc.setFontSize(24);
            doc.setFont('Inter-SemiBold');
            doc.setTextColor('#0A2156');
            doc.text(title, pageWidth / 2, 45, { align: 'center' });

            renderHeader();
        };

        autoTable(doc, {
            body: [
                [
                    {
                        content: 'Solicitante:',
                        styles: {
                            halign: 'left',
                            valign: 'middle',
                            font: 'Inter-SemiBold',
                            fontSize: 10,
                            textColor: '#0a2156',
                            cellPadding: {
                                left: 4,
                                top: 2,
                                right: 4,
                            },
                        },
                    },
                ],
                [
                    {
                        content: request.SOLR_NomeRazaoSocial
                            ? `${hideCpfIn(this.formatCpfCnpj(request.SOLR_CpfCnpj))} - ${request.SOLR_NomeRazaoSocial}`
                            : `${hideCpfIn(this.formatCpfCnpj(request.PE_CPF))} - ${request.PE_Nome}`,
                        styles: {
                            halign: 'left',
                            valign: 'top',
                            fontSize: 11,
                            textColor: '#687489',
                            overflow: 'linebreak',
                            cellWidth: 180,
                            minCellHeight: 8,
                            cellPadding: {
                                left: 4,
                                top: 2,
                                right: 4,
                                bottom: 2,
                            },
                        },
                    },
                ],
            ],
            theme: 'plain',
            startY: 55,
            styles: {
                fillColor: '#f2f5f9',
            },
            margin: {
                left: 15,
                right: 15,
            },
        });

        const solicitanteFinalY = (doc as any).lastAutoTable.finalY;

        autoTable(doc, {
            body: [
                [
                    {
                        content: 'Órgão:',
                        styles: {
                            halign: 'left',
                            valign: 'middle',
                            font: 'Inter-SemiBold',
                            cellWidth: 'wrap',
                            fontSize: 10,
                            textColor: '#0a2156',
                            cellPadding: { left: 4, top: 2, right: 4 },
                        },
                    },
                    {
                        content: 'Assunto:',
                        styles: {
                            halign: 'left',
                            valign: 'middle',
                            font: 'Inter-SemiBold',
                            cellWidth: 'auto',
                            fontSize: 10,
                            textColor: '#0a2156',
                            cellPadding: { left: 4, top: 2, right: 4 },
                            lineWidth: { left: 1, top: 0, right: 0, bottom: 0 },
                            lineColor: '#ffffff',
                        },
                    },
                ],
                [
                    {
                        content: request.OR_Descricao,
                        styles: {
                            halign: 'left',
                            fontSize: 12,
                            textColor: '#687489',
                            cellPadding: {
                                left: 4,
                                top: 2,
                                right: 4,
                                bottom: 2,
                            },
                        },
                    },
                    {
                        content: request.AS_Descricao,
                        styles: {
                            halign: 'left',
                            fontSize: 12,
                            textColor: '#687489',
                            cellPadding: {
                                left: 4,
                                top: 2,
                                right: 4,
                                bottom: 2,
                            },
                            lineWidth: { left: 1, top: 0, right: 0, bottom: 0 },
                            lineColor: '#ffffff',
                        },
                    },
                ],
            ],
            theme: 'plain',
            startY: solicitanteFinalY + 4,
            styles: {
                fillColor: '#f2f5f9',
            },
        });
        const departamentoFinalY = (doc as any).lastAutoTable.finalY;

        if (request.SOLR_CpfCnpj) {
            autoTable(doc, {
                body: [
                    [
                        {
                            content: 'Observações:',
                            styles: {
                                halign: 'left',
                                valign: 'middle',
                                font: 'Inter-SemiBold',
                                cellWidth: 'wrap',
                                fontSize: 10,
                                textColor: '#0a2156',
                                cellPadding: { left: 4, top: 2, right: 4 },
                            },
                        },
                    ],
                    [
                        {
                            content: 'A Solicitação foi realizada por Terceiros.',
                            styles: {
                                halign: 'left',
                                fontSize: 12,
                                textColor: '#687489',
                                cellPadding: {
                                    left: 4,
                                    top: 2,
                                    right: 4,
                                    bottom: 2,
                                },
                            },
                        },
                    ],
                ],
                theme: 'plain',
                startY: departamentoFinalY + 4,
                styles: {
                    fillColor: '#f2f5f9',
                },
            });
        }
        const observacaoFinalY = (doc as any).lastAutoTable.finalY;

        const descricaoTitleY = request.SOLR_CpfCnpj
            ? observacaoFinalY + 10
            : departamentoFinalY + 10;

        doc.setFont('Inter-SemiBold');
        doc.setFontSize(12);
        doc.setTextColor('#0A2156');
        doc.text('Descrição da solicitação', 15, descricaoTitleY);

        autoTable(doc, {
            startY: descricaoTitleY + 5,
            pageBreak: 'auto',
            rowPageBreak: 'auto',
            body: [
                [
                    {
                        content: hideCpfIn(request.SOL_Descricao || '')
                            .replace(/\r\n/g, '\n')
                            .replace(/\r/g, '\n'),
                        styles: {
                            font: 'Inter-Regular',
                            fontSize: 11,
                            textColor: '#687489',
                            overflow: 'linebreak',
                            valign: 'top',
                            cellPadding: 2,
                            cellWidth: 180,
                        },
                    },
                ],
            ],
            theme: 'plain',
            styles: {
                fillColor: '#F2F5F9',
            },
            margin: {
                left: 15,
                right: 15,
                top: 50,
                bottom: 70,
            },
        });

        renderFooter(qrcodeImage);

        addNewPage('Folha de Registros');

        const historicosData = (request.historicos || []).map((historico) => [
            this.datePipe.transform(historico.SOLH_Data, "dd/MM/yyyy 'às' HH:mm:ss"),
            hideCpfIn(historico.SOLH_Historico),
        ]);

        autoTable(doc, {
            head: [['Data', 'Histórico']],
            body: historicosData,
            theme: 'striped',
            startY: 65,
            styles: {
                font: 'Inter-Regular',
                minCellHeight: 8,
                valign: 'middle',
                halign: 'left',
            },
            alternateRowStyles: {
                fillColor: '#F2F5F9',
            },
            headStyles: {
                fillColor: '#417bff',
                font: 'Inter-SemiBold',
                minCellHeight: 8,
                valign: 'middle',
                halign: 'left',
            },
        });

        if (this.organizationIsSemurb && request.consideracoes && request.consideracoes.length > 0) {
            addNewPage('Considerações');

            const consideracoesData = request.consideracoes.map((consideracao) => {
                const dataFormatada = consideracao.SOLC_DataCorrecao 
                    ? this.datePipe.transform(consideracao.SOLC_DataCorrecao, "dd/MM/yyyy 'às' HH:mm:ss")
                    : this.datePipe.transform(consideracao.created_at, "dd/MM/yyyy 'às' HH:mm:ss");
                
                let status = 'Pendente';
                if (consideracao.SOLC_Status === 1) {
                    status = 'Corrigido';
                } else if (consideracao.SOLC_Status === 2) {
                    status = 'Em análise';
                }
                
                const descricao = hideCpfIn(consideracao.SOLC_Descricao?.trim());
                
                return [
                    dataFormatada,
                    descricao,
                    status,
                ];
            });

            autoTable(doc, {
                head: [['Data', 'Descrição', 'Status']],
                body: consideracoesData,
                theme: 'striped',
                startY: 65,
                styles: {
                    font: 'Inter-Regular',
                    minCellHeight: 8,
                    valign: 'middle',
                    halign: 'left',
                },
                alternateRowStyles: {
                    fillColor: '#F2F5F9',
                },
                headStyles: {
                    fillColor: '#417bff',
                    font: 'Inter-SemiBold',
                    minCellHeight: 8,
                    valign: 'middle',
                    halign: 'left',
                },
                columnStyles: {
                    0: { cellWidth: 30 },
                    1: { cellWidth: 'auto' },
                    2: { cellWidth: 25 },
                },
                didParseCell: (data) => {
                    if (data.row.index > 0 && data.column.index === 2) {
                        switch(data.cell.raw) {
                            case 'Pendente':
                                data.cell.styles.textColor = '#dc3545';
                                data.cell.styles.fontStyle = 'bold';
                                break;
                            case 'Corrigido':
                                data.cell.styles.textColor = '#28a745';
                                data.cell.styles.fontStyle = 'bold';
                                break;
                            case 'Em análise':
                                data.cell.styles.textColor = '#ffc107';
                                data.cell.styles.fontStyle = 'bold';
                                break;
                        }
                    }
                }
            });
        }

        const brasaoSga = new Image();
        brasaoSga.src = '../../assets/img/brand/brasao-sga.png';
        doc.addImage(brasaoSga, 'png', 73, 275, 20, 18);

        const line = new Image();
        line.src = '../../assets/img/brand/line.png';
        doc.addImage(line, 'png', 100, 280, 0.2, 10);

        doc.setFont('Inter-Regular');
        doc.setFontSize(12);
        doc.setTextColor('#0A2156');
        doc.text(request.OR_Descricao, 107, 279, { maxWidth: 40 });

        if (request.SOLR_CpfCnpj) {
            doc.addPage();
            doc.addImage(logoProtocolize, 'PNG', 55, 5, 95, 18);
            doc.setFont('Inter-Bold');
            doc.setFontSize(10);
            doc.setTextColor('#000000');
            doc.text('Termo de responsabilidade para abertura de processo', 15, 25);

            doc.setFont('Inter-Regular');
            doc.setFontSize(9);
            doc.setTextColor('#000000');
            doc.text(
                `Eu, ${request.SOLR_NomeRazaoSocial}, portador do documento de CPF n° ${hideCpfIn(this.formatCpfCnpj(request.SOLR_CpfCnpj))}, venho por meio deste, solicitar a abertura de um processo administrativo referente a ${request.AS_Descricao}, com o número de solicitação ${request.SOL_NumeroSolicitacao}/${request.SOL_AnoSolicitacao}, junto à ${request.OR_Descricao}, através da equipe de triagem.`,
                15, 30, { maxWidth: 175, align: 'justify' }
            );
            
            doc.text('Declaro estar ciente e concordar com as seguintes condições:', 15, 47);

            const terms = [
                {
                  title: '1. Responsabilidade pelo Acompanhamento:  Comprometo-me  a  acompanhar  o  andamento do meu processo diretamente junto ao órgão responsável,  seja por meio de telefone ou e-mail, cujos contatos me foram informados no ato da abertura do processo.',
                  style: { align: 'justify', maxWidth: 178 },
                  space: 10
                },
                {
                  title: '2. Correções e Prazos: Caso o processo seja devolvido para correção de pendências ou ajustes, reconheço que terei o  prazo máximo de 10 (dez) dias corridos para realizar as devidas correções. Caso o prazo não seja cumprido, estou ciente de que o processo será indeferido, e será necessário abrir um novo processo para dar continuidade à solicitação. As correções só poderão ser realizadas no departamento de triagem do órgão em que o processo foi originalmente aberto.',
                  style: { align: 'justify', maxWidth: 178 },
                  space: 14
                },
                {
                  title: '3. Compromisso com  as  Informações: Declaro que todas  as  informações fornecidas no ato da abertura  do  processo  são verdadeiras e precisas, e assumo total responsabilidade por qualquer erro ou omissão.',
                  style: {  maxWidth: 180, align: 'justify' },
                  space: 1
                },
              ];

            let currentY = 55;
            const pageWidth = doc.internal.pageSize.getWidth();

            terms.forEach(term => {
                const [boldText, ...normalTextArray] = term.title.split(':');
                const normalText = normalTextArray.join(':').trim();
            
                doc.setFont('helvetica', 'bold');
                doc.text(`${boldText}: `, 15, currentY);
            
                const boldTextWidth = doc.getTextWidth(`${boldText}: `);
                doc.setFont('helvetica', 'normal');
            
                const maxWidth = pageWidth - 30; 
                const lineSpacing = 4;          
            
                const firstLine = doc.splitTextToSize(normalText, maxWidth - boldTextWidth)[0];
                doc.text(firstLine, 15 + boldTextWidth, currentY, { align: 'justify' });
            
                currentY += lineSpacing;
            
                const remainingText = normalText.substring(firstLine.length).trim();

                doc.text(remainingText, 15, currentY, { align: 'justify', maxWidth: term.style.maxWidth });
                currentY += term.space;
            });

            currentY += 4;
            doc.text(
                'Ao assinar este termo, estou ciente e de acordo com todas as condições descritas, e comprometo-me a cumprir com minhas responsabilidades.',
                15, currentY, { maxWidth: 175, align: 'justify' }
            );

            currentY += 10;
            const finalText = 'São Gonçalo do Amarante - CE, ' + new Date().toLocaleDateString() + '.';
            const textWidth = doc.getTextWidth(finalText);
            doc.text(finalText, pageWidth - textWidth - 14, currentY);
            doc.text('_____________________________________________________________', pageWidth / 2, currentY + 10, { align: 'center' });
            doc.text('Assinatura do Responsável', pageWidth / 2, currentY + 15, { align: 'center' });

            currentY += 20;

            const logoSga = new Image();
            logoSga.src = '../../assets/img/brand/logo_sga_horizontal.png';
            doc.addImage(logoSga, 'png', 50, currentY, 60, 12);
            
            doc.addImage(line, 'png', 105, currentY + 2, 0.2, 10);

            doc.setFont('Inter-Regular');
            doc.setFontSize(12);
            doc.setTextColor('#0A2156');
            doc.text(request.OR_Descricao, 108, currentY + 6, { maxWidth: 40 });

            currentY += 20;
            doc.setLineDashPattern([2, 1], 0);
            doc.line(5, currentY, pageWidth - 4, currentY);

            currentY += 2;

            doc.addImage(logoProtocolize, 'PNG', 57, currentY, 95, 18);

            currentY += 20;
            doc.setFont('Inter-Bold');
            doc.setFontSize(10);
            doc.setTextColor('#000000');
            doc.text('Termo de responsabilidade para abertura de processo', 15, currentY);

            currentY += 1;
            doc.setFont('Inter-Regular');
            doc.setFontSize(9);
            doc.setTextColor('#000000');
            doc.text(
                `Eu, ${request.SOLR_NomeRazaoSocial}, portador do documento de CPF n° ${hideCpfIn(this.formatCpfCnpj(request.SOLR_CpfCnpj))}, venho por meio deste, solicitar a abertura de um processo administrativo referente a ${request.AS_Descricao}, com o número de solicitação ${request.SOL_NumeroSolicitacao}/${request.SOL_AnoSolicitacao}, junto à Secretaria Municipal de Finanças, através da equipe de triagem.`,
                15, currentY + 4, { maxWidth: 175, align: 'justify' }
            );

            currentY += 20;
            doc.text('Declaro estar ciente e concordar com as seguintes condições:', 15, currentY);

            currentY += 10;
            terms.forEach(term => {
                const [boldText, ...normalTextArray] = term.title.split(':');
                const normalText = normalTextArray.join(':').trim();
            
                doc.setFont('helvetica', 'bold');
                doc.text(`${boldText}: `, 15, currentY);
            
                const boldTextWidth = doc.getTextWidth(`${boldText}: `);
                doc.setFont('helvetica', 'normal');
            
                const maxWidth = pageWidth - 30; 
                const lineSpacing = 4;          
            
                const firstLine = doc.splitTextToSize(normalText, maxWidth - boldTextWidth)[0];
                doc.text(firstLine, 15 + boldTextWidth, currentY, { align: 'justify' });
            
                currentY += lineSpacing;
            
                const remainingText = normalText.substring(firstLine.length).trim();

                doc.text(remainingText, 15, currentY, { align: 'justify', maxWidth: term.style.maxWidth });
                currentY += term.space;
            });

            currentY += 6;
            doc.text(
                'Ao assinar este termo, estou ciente e de acordo com todas as condições descritas, e comprometo-me a cumprir com minhas responsabilidades.',
                15, currentY, { maxWidth: 175, align: 'justify' }
            );

            currentY += 15;
            doc.text(finalText, pageWidth - textWidth - 20, currentY);
            doc.text('_____________________________________________________________', pageWidth / 2, currentY + 10, { align: 'center' });
            doc.text('Assinatura do Responsável', pageWidth / 2, currentY + 15, { align: 'center' });

            currentY += 20;

            logoSga.src = '../../assets/img/brand/logo_sga_horizontal.png';
            doc.addImage(logoSga, 'png', 50, currentY, 60, 12);

            currentY += 20;

            doc.addImage(line, 'png', 105, 279, 0.2, 10);

            doc.setFont('Inter-Regular');
            doc.setFontSize(12);
            doc.setTextColor('#0A2156');
            doc.text(request.OR_Descricao, 108, 283, { maxWidth: 40 });
        }
        
        const totalPages = doc.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i);
            renderFooter(qrcodeImage);
        }

        const listBlobPdf = [
            { name: requestGeneratesDocumentsName.REQUEST, file: doc.output('blob') }, 
            { name: requestGeneratesDocumentsName.DOCUMENT_OF_REQUEST, file: this.generatePageDocumentCover(request, "DOCUMENTOS DA SOLICITAÇÃO", "#0A2156", qrcode, 28)},
        ]


        return listBlobPdf;
    }

    public generatePageDocumentCover(request: Request, text: string, color: string,  qrcode, fontSize = 36): Blob {
        const doc = new jsPDF('p', 'mm', 'a4');
        const pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

        const logoProtocolize = new Image();
        logoProtocolize.src = '../../assets/img/brand/logo-protocolizesga.png';
        doc.addImage(logoProtocolize, 'png', 60, 5, 95, 18);

        doc.addFileToVFS('Inter-Bold.ttf', interSemiBold);
        doc.addFont('Inter-Bold.ttf', 'Inter-Bold', 'normal');
        doc.setFont('Inter-SemiBold');

        doc.addFileToVFS('Inter-Regular.ttf', interRegular);
        doc.addFont('Inter-Regular.ttf', 'Inter-Regular', 'normal');

        doc.setFontSize(12);
        doc.setTextColor('#0A2156');
        doc.text('Sistema de Protocolo e Tramitação Eletrônica', pageWidth / 2, 30, {
            align: 'center',
        });

        doc.setFontSize(fontSize);
        doc.setFont('Inter-SemiBold');
        doc.setTextColor(color);
        doc.text(text, pageWidth / 2, 140, { align: 'center' });

        autoTable(doc, {
            body: [
                [
                    {
                        content: `Situação em ${this.datePipe.transform(new Date(), "dd/MM/yyyy 'às' HH:mm:ss")}`,
                        styles: {
                            halign: 'left',
                            valign: 'middle',
                            font: 'Inter-SemiBold',
                            cellWidth: 70,
                            fontSize: 10,
                            cellPadding: {
                                bottom: 0,
                                top: 0,
                                right: 0,
                                left: 3,
                            },
                            textColor: '#0A2156',
                        },
                    },
                    {
                        content: this.getStatusDescription(request.SOL_Status),
                        styles: {
                            halign: 'left',
                            fontSize: 10,
                            cellWidth: 85,
                            cellPadding: 3,
                            textColor: '#687489',
                        },
                    },
                    {
                        rowSpan: 3,
                        styles: {
                            halign: 'center',
                            valign: 'middle',
                            fontSize: 10,
                            textColor: '#687489',
                        },
                    },
                ],
                [
                    {
                        content: 'Unidade Atual',
                        styles: {
                            halign: 'left',
                            valign: 'middle',
                            font: 'Inter-SemiBold',
                            cellWidth: 70,
                            fontSize: 10,
                            cellPadding: 3,
                            textColor: '#0A2156',
                        },
                    },
                    {
                        content: request.OR_Sigla,
                        styles: {
                            halign: 'left',
                            fontSize: 10,
                            cellPadding: 3,
                            textColor: '#687489',
                        },
                    },
                ],
            ],
            theme: 'plain',
            startY: 250,
            styles: {
                lineWidth: 0.2,
                lineColor: '#687489',
                font: 'Inter-Regular',
            },
        });

        doc.addImage(qrcode, 'PNG', 172, 251, 20, 19);

        const logoSga = new Image();
        logoSga.src = '../../assets/img/brand/brasao-sga.png';
        doc.addImage(logoSga, 'png', 73, 275, 20, 18);

        const line = new Image();
        line.src = '../../assets/img/brand/line.png';
        doc.addImage(line, 'png', 100, 280, 0.2, 10);

        doc.setFont('Inter-Regular');
        doc.setFontSize(12);
        doc.setTextColor('#0A2156');
        doc.text(request.OR_Descricao, 107, 279, { maxWidth: 40 });

        return doc.output('blob');
    }


    public generateRequestPDF(request: Request, hideCpf = false) {
        const hideCpfIn = (text: string) => hideCpf ? this.maskCpf(text) : text;
        const doc = new jsPDF('p', 'mm', 'a4');

        const logoProtocolize = new Image();
        const urlPublicRequest = environment.projectURL + '/free/solicitacao/' + request.SOL_CodigoSolicitacao;
        let qrcode: string;

        QRCode.toDataURL(urlPublicRequest, (_, url) => {
            var base64Data = url.split(',')[1];
            qrcode = atob(base64Data);
        });

        logoProtocolize.src = '../../assets/img/brand/logo-protocolizesga.png';
        doc.addImage(logoProtocolize, 'png', 57, 5, 95, 18);

        doc.addFileToVFS('Inter-Bold.ttf', interSemiBold);
        doc.addFont('Inter-Bold.ttf', 'Inter-Bold', 'normal');
        doc.setFont('Inter-SemiBold');

        doc.addFileToVFS('Inter-Regular.ttf', interRegular);
        doc.addFont('Inter-Regular.ttf', 'Inter-Regular', 'normal');

        doc.setFont('Inter-SemiBold');
        doc.setFontSize(16);
        doc.setTextColor('#0A2156');
        doc.text((request.SOLR_TipoOrgaoFiscalizador ? 'Protocolo N° ' : 'Solicitação N° ') + request.SOL_NumeroSolicitacao + '/' + request.SOL_AnoSolicitacao, 103, 35, { align: 'center' });

        const requestDateFormatted = this.datePipe.transform(request.SOL_DataSolicitacao, 'dd/MM/yyyy');

        doc.setFont('Inter-Regular');
        doc.setFontSize(12);
        doc.setTextColor('#687489');
        doc.text('Data da solicitação: ' + requestDateFormatted, 103, 42, {
            align: 'center',
        });

        autoTable(doc, {
            body: [
                [
                    {
                        content: 'Solicitante:',
                        styles: {
                            halign: 'left',
                            valign: 'middle',
                            font: 'Inter-SemiBold',
                            cellWidth: 'wrap',
                            fontSize: 10,
                            textColor: '#0a2156',
                            cellPadding: { left: 4, top: 2, right: 4 },
                        },
                    },
                ],
                [
                    {
                        content: request.SOLR_NomeRazaoSocial
                            ? `${hideCpfIn(this.formatCpfCnpj(request.SOLR_CpfCnpj))} - ${request.SOLR_NomeRazaoSocial}`
                            : `${hideCpfIn(this.formatCpfCnpj(request.PE_CPF))} - ${request.PE_Nome}`,
                        styles: {
                            halign: 'left',
                            fontSize: 12,
                            textColor: '#687489',
                            cellPadding: {
                                left: 4,
                                top: 2,
                                right: 4,
                                bottom: 2,
                            },
                        },
                    },
                ],
            ],
            theme: 'plain',
            startY: 55,
            styles: {
                fillColor: '#f2f5f9',
            },
        });

        autoTable(doc, {
            body: [
                [
                    {
                        content: 'Órgão:',
                        styles: {
                            halign: 'left',
                            valign: 'middle',
                            font: 'Inter-SemiBold',
                            cellWidth: 'wrap',
                            fontSize: 10,
                            textColor: '#0a2156',
                            cellPadding: { left: 4, top: 2, right: 4 },
                        },
                    },
                    {
                        content: 'Assunto:',
                        styles: {
                            halign: 'left',
                            valign: 'middle',
                            font: 'Inter-SemiBold',
                            cellWidth: 'auto',
                            fontSize: 10,
                            textColor: '#0a2156',
                            cellPadding: { left: 4, top: 2, right: 4 },
                            lineWidth: { left: 1, top: 0, right: 0, bottom: 0 },
                            lineColor: '#ffffff',
                        },
                    },
                ],
                [
                    {
                        content: request.OR_Descricao,
                        styles: {
                            halign: 'left',
                            fontSize: 12,
                            textColor: '#687489',
                            cellPadding: {
                                left: 4,
                                top: 2,
                                right: 4,
                                bottom: 2,
                            },
                        },
                    },
                    {
                        content: request.AS_Descricao,
                        styles: {
                            halign: 'left',
                            fontSize: 12,
                            textColor: '#687489',
                            cellPadding: {
                                left: 4,
                                top: 2,
                                right: 4,
                                bottom: 2,
                            },
                            lineWidth: { left: 1, top: 0, right: 0, bottom: 0 },
                            lineColor: '#ffffff',
                        },
                    },
                ],
            ],
            theme: 'plain',
            startY: (doc as any).lastAutoTable.finalY + 6,
            styles: {
                fillColor: '#f2f5f9',
            },
        });

        if (request.SOLR_CpfCnpj) {
            autoTable(doc, {
                body: [
                    [
                        {
                            content: 'Observações:',
                            styles: {
                                halign: 'left',
                                valign: 'middle',
                                font: 'Inter-SemiBold',
                                cellWidth: 'wrap',
                                fontSize: 10,
                                textColor: '#0a2156',
                                cellPadding: { left: 4, top: 2, right: 4 },
                            },
                        },
                    ],
                    [
                        {
                            content: 'A Solicitação foi realizada por Terceiros.',
                            styles: {
                                halign: 'left',
                                fontSize: 12,
                                textColor: '#687489',
                                cellPadding: {
                                    left: 4,
                                    top: 2,
                                    right: 4,
                                    bottom: 2,
                                },
                            },
                        },
                    ],
                ],
                theme: 'plain',
                startY: (doc as any).lastAutoTable.finalY + 6,
                styles: {
                    fillColor: '#f2f5f9',
                },
            });
        }

        autoTable(doc, {
            body: [
                [
                    {
                        content: 'Descrição da solicitação:',
                        styles: {
                            halign: 'left',
                            valign: 'middle',
                            font: 'Inter-SemiBold',
                            cellWidth: 'wrap',
                            fontSize: 10,
                            textColor: '#0a2156',
                            cellPadding: { left: 4, top: 2, right: 4 },
                        },
                    },
                ],
                [
                    {
                        content: hideCpfIn(request.SOL_Descricao),
                        styles: {
                            halign: 'left',
                            fontSize: 12,
                            textColor: '#687489',
                            cellPadding: {
                                left: 4,
                                top: 2,
                                right: 4,
                                bottom: 2,
                            },
                        }
                    },
                ],
            ],
            theme: 'plain',
            startY: (doc as any).lastAutoTable.finalY + 6,
            styles: {
                fillColor: '#f2f5f9',
            },
        });

        const situacaoTableY = (doc as any).lastAutoTable.finalY + 6;

        autoTable(doc, {
            body: [
                [
                    {
                        content: 'Situação:',
                        styles: {
                            halign: 'center',
                            valign: 'middle',
                            font: 'Inter-SemiBold',
                            cellWidth: 30,
                            fontSize: 12,
                            cellPadding: {
                                bottom: 0,
                                top: 0,
                                right: 0,
                                left: 0,
                            },
                            textColor: '#0A2156',
                        },
                    },
                    {
                        content: this.getStatusDescription(request.SOL_Status),
                        styles: {
                            halign: 'left',
                            fontSize: 12,
                            cellPadding: 3,
                            textColor: '#687489',
                        },
                    },
                    {
                        content: '',
                        rowSpan: 2,
                        styles: {
                            halign: 'center',
                            valign: 'middle',
                            fontSize: 12,
                            cellPadding: 6,
                            textColor: '#687489',
                            cellWidth: 28,
                        },
                    },
                ],
                [
                    {
                        content: 'Chave de verificação:',
                        styles: {
                            halign: 'center',
                            valign: 'middle',
                            font: 'Inter-SemiBold',
                            cellWidth: 50,
                            fontSize: 12,
                            cellPadding: {
                                bottom: 0,
                                top: 0,
                                right: 0,
                                left: 0,
                            },
                            textColor: '#0A2156',
                        },
                    },
                    {
                        content: request.SOL_ChaveAutenticidade,
                        styles: {
                            halign: 'left',
                            fontSize: 12,
                            cellPadding: 3,
                            textColor: '#687489',
                        },
                    },
                ],
                [
                    {
                        content:
                            'Acompanhe sua solicitação acessando https://web.protocolize.pmsga.ce.gov.br/principal ou aponte a câmera do seu celular para o QR Code ao lado.',
                        colSpan: 3,
                        styles: {
                            halign: 'left',
                            fontSize: 12,
                            cellPadding: 3,
                            textColor: '#687489',
                        },
                    },
                ],
            ],
            theme: 'plain',
            startY: situacaoTableY,
            styles: {
                lineWidth: 0.2,
                lineColor: '#687489',
                font: 'Inter-Regular',
            },
            didDrawCell: (data: any) => {
                if (data.row.index === 0 && data.column.index === 2) {
                    const maxWidth = 23;
                    const maxHeight = 22;
                    const scale = Math.min(1, (data.cell.width - 4) / maxWidth, (data.cell.height - 4) / maxHeight);
                    const imgWidth = maxWidth * scale;
                    const imgHeight = maxHeight * scale;
                    const x = data.cell.x + (data.cell.width - imgWidth) / 2;
                    const y = data.cell.y + (data.cell.height - imgHeight) / 2;
                    doc.addImage(qrcode, 'PNG', x, y, imgWidth, imgHeight);
                }
            },
        });

        const footerY = (doc as any).lastAutoTable.finalY;
        const brasaoSga = new Image();
        brasaoSga.src = '../../assets/img/brand/brasao-sga.png';
        doc.addImage(brasaoSga, 'png', 73, footerY + 8, 20, 18);

        const line = new Image();
        line.src = '../../assets/img/brand/line.png';
        doc.addImage(line, 'png', 100, footerY + 13, 0.2, 10);

        doc.setFont('Inter-Regular');
        doc.setFontSize(12);
        doc.setTextColor('#0A2156');
        doc.text(request.OR_Descricao, 107, footerY + 17, { maxWidth: 40 });

        if (request.SOLR_CpfCnpj) {
            doc.addPage();
            doc.addImage(logoProtocolize, 'PNG', 55, 5, 95, 18);
            doc.setFont('Inter-Bold');
            doc.setFontSize(10);
            doc.setTextColor('#000000');
            doc.text('Termo de responsabilidade para abertura de processo', 15, 25);

            doc.setFont('Inter-Regular');
            doc.setFontSize(9);
            doc.setTextColor('#000000');
            doc.text(
                `Eu, ${request.SOLR_NomeRazaoSocial}, portador do documento de CPF n° ${hideCpfIn(this.formatCpfCnpj(request.SOLR_CpfCnpj))}, venho por meio deste, solicitar a abertura de um processo administrativo referente a ${request.AS_Descricao}, com o número de solicitação ${request.SOL_NumeroSolicitacao}/${request.SOL_AnoSolicitacao}, junto à ${request.OR_Descricao}, através da equipe de triagem.`,
                15, 30, { maxWidth: 175, align: 'justify' }
            );
            
            doc.text('Declaro estar ciente e concordar com as seguintes condições:', 15, 47);

            const terms = [
                {
                  title: '1. Responsabilidade pelo Acompanhamento:  Comprometo-me  a  acompanhar  o  andamento do meu processo diretamente junto ao órgão responsável,  seja por meio de telefone ou e-mail, cujos contatos me foram informados no ato da abertura do processo.',
                  style: { align: 'justify', maxWidth: 178 },
                  space: 10
                },
                {
                  title: '2. Correções e Prazos: Caso o processo seja devolvido para correção de pendências ou ajustes, reconheço que terei o  prazo máximo de 10 (dez) dias corridos para realizar as devidas correções. Caso o prazo não seja cumprido, estou ciente de que o processo será indeferido, e será necessário abrir um novo processo para dar continuidade à solicitação. As correções só poderão ser realizadas no departamento de triagem do órgão em que o processo foi originalmente aberto.',
                  style: { align: 'justify', maxWidth: 178 },
                  space: 14
                },
                {
                  title: '3. Compromisso com  as  Informações: Declaro que todas  as  informações fornecidas no ato da abertura  do  processo  são verdadeiras e precisas, e assumo total responsabilidade por qualquer erro ou omissão.',
                  style: {  maxWidth: 180, align: 'justify' },
                  space: 1
                },
              ];

            let currentY = 55;
            const pageWidth = doc.internal.pageSize.getWidth();

            terms.forEach(term => {
                const [boldText, ...normalTextArray] = term.title.split(':');
                const normalText = normalTextArray.join(':').trim();
            
                doc.setFont('helvetica', 'bold');
                doc.text(`${boldText}: `, 15, currentY);
            
                const boldTextWidth = doc.getTextWidth(`${boldText}: `);
                doc.setFont('helvetica', 'normal');
            
                const maxWidth = pageWidth - 30; 
                const lineSpacing = 4;          
            
                const firstLine = doc.splitTextToSize(normalText, maxWidth - boldTextWidth)[0];
                doc.text(firstLine, 15 + boldTextWidth, currentY, { align: 'justify' });
            
                currentY += lineSpacing;
            
                const remainingText = normalText.substring(firstLine.length).trim();

                doc.text(remainingText, 15, currentY, { align: 'justify', maxWidth: term.style.maxWidth });
                currentY += term.space;
            });

            currentY += 4;
            doc.text(
                'Ao assinar este termo, estou ciente e de acordo com todas as condições descritas, e comprometo-me a cumprir com minhas responsabilidades.',
                15, currentY, { maxWidth: 175, align: 'justify' }
            );

            currentY += 10;
            const finalText = 'São Gonçalo do Amarante - CE, ' + new Date().toLocaleDateString() + '.';
            const textWidth = doc.getTextWidth(finalText);
            doc.text(finalText, pageWidth - textWidth - 14, currentY);
            doc.text('_____________________________________________________________', pageWidth / 2, currentY + 10, { align: 'center' });
            doc.text('Assinatura do Responsável', pageWidth / 2, currentY + 15, { align: 'center' });

            currentY += 20;

            const logoSga = new Image();
            logoSga.src = '../../assets/img/brand/logo_sga_horizontal.png';
            doc.addImage(logoSga, 'png', 50, currentY, 60, 12);
            
            doc.addImage(line, 'png', 105, currentY + 2, 0.2, 10);

            doc.setFont('Inter-Regular');
            doc.setFontSize(12);
            doc.setTextColor('#0A2156');
            doc.text(request.OR_Descricao, 108, currentY + 6, { maxWidth: 40 });

            currentY += 20;
            doc.setLineDashPattern([2, 1], 0);
            doc.line(5, currentY, pageWidth - 4, currentY);

            currentY += 2;

            doc.addImage(logoProtocolize, 'PNG', 57, currentY, 95, 18);

            currentY += 20;
            doc.setFont('Inter-Bold');
            doc.setFontSize(10);
            doc.setTextColor('#000000');
            doc.text('Termo de responsabilidade para abertura de processo', 15, currentY);

            currentY += 1;
            doc.setFont('Inter-Regular');
            doc.setFontSize(9);
            doc.setTextColor('#000000');
            doc.text(
                `Eu, ${request.SOLR_NomeRazaoSocial}, portador do documento de CPF n° ${hideCpfIn(this.formatCpfCnpj(request.SOLR_CpfCnpj))}, venho por meio deste, solicitar a abertura de um processo administrativo referente a ${request.AS_Descricao}, com o número de solicitação ${request.SOL_NumeroSolicitacao}/${request.SOL_AnoSolicitacao}, junto à Secretaria Municipal de Finanças, através da equipe de triagem.`,
                15, currentY + 4, { maxWidth: 175, align: 'justify' }
            );

            currentY += 20;
            doc.text('Declaro estar ciente e concordar com as seguintes condições:', 15, currentY);

            currentY += 10;
            terms.forEach(term => {
                const [boldText, ...normalTextArray] = term.title.split(':');
                const normalText = normalTextArray.join(':').trim();
            
                doc.setFont('helvetica', 'bold');
                doc.text(`${boldText}: `, 15, currentY);
            
                const boldTextWidth = doc.getTextWidth(`${boldText}: `);
                doc.setFont('helvetica', 'normal');
            
                const maxWidth = pageWidth - 30; 
                const lineSpacing = 4;          
            
                const firstLine = doc.splitTextToSize(normalText, maxWidth - boldTextWidth)[0];
                doc.text(firstLine, 15 + boldTextWidth, currentY, { align: 'justify' });
            
                currentY += lineSpacing;
            
                const remainingText = normalText.substring(firstLine.length).trim();

                doc.text(remainingText, 15, currentY, { align: 'justify', maxWidth: term.style.maxWidth });
                currentY += term.space;
            });

            currentY += 6;
            doc.text(
                'Ao assinar este termo, estou ciente e de acordo com todas as condições descritas, e comprometo-me a cumprir com minhas responsabilidades.',
                15, currentY, { maxWidth: 175, align: 'justify' }
            );

            currentY += 15;
            doc.text(finalText, pageWidth - textWidth - 20, currentY);
            doc.text('_____________________________________________________________', pageWidth / 2, currentY + 10, { align: 'center' });
            doc.text('Assinatura do Responsável', pageWidth / 2, currentY + 15, { align: 'center' });

            currentY += 20;

            logoSga.src = '../../assets/img/brand/logo_sga_horizontal.png';
            doc.addImage(logoSga, 'png', 50, currentY, 60, 12);

            currentY += 20;

            doc.addImage(line, 'png', 105, 279, 0.2, 10);

            doc.setFont('Inter-Regular');
            doc.setFontSize(12);
            doc.setTextColor('#0A2156');
            doc.text(request.OR_Descricao, 108, 283, { maxWidth: 40 });
        }

        return doc.save(`Comprovante de Solicitação - N° ${request.SOL_CodigoSolicitacao}`);
    }

    getStatusDescription(requestStatus: number) {
        const statusDescriptions = {
            0: 'Em Processo de Triagem',
            1: 'Solicitação Aceita',
            2: 'Correção de Pendências',
            3: 'Anulada',
            4: 'Corrigida',
            6: 'Aguardando Assinatura do Responsável'
        };

        return statusDescriptions[requestStatus];
    }

    /** Classes do badge (ui-badge) de cada status de solicitação; mesma ordem de getStatusDescription. */
    getStatusBadge(requestStatus: number, size: 'sm' | 'md' | 'lg' = 'sm'): string {
        const colors = {
            0: 'brand',
            1: 'success',
            2: 'warning',
            3: 'error',
            4: 'blue-light',
            5: 'gray',
            6: 'purple',
        };

        return `ui-badge ui-badge--${size} ui-badge--${colors[requestStatus] || 'gray'}`;
    }

    public isInEvaluation(status: number): boolean {
        return RequestStatusEnum.evaluation == status;
    }

    public isInCorrection(status: number): boolean {
        return RequestStatusEnum.correction == status;
    }

    public isAccepted(status: number): boolean {
        return RequestStatusEnum.accepted == status;
    }

    public viewPublicRequest(id: number) {
        return this.http.get(this.apiURL() + '/api/free/solicitacao/' + id);
    }

    public cancelRequest(data: ICancelRequestSchema): Observable<any> {
        return this.http.post(this.apiURL() + '/api/requests/cancel-request', data, this.headers())
            .pipe(
                catchError(this.handleError)
            );
    }

    private handleError(error: any): Observable<never> {
        console.error('An error occurred:', error);
        return throwError(() => new Error('Something went wrong; please try again later.'));
    }

    public updateProcessDescription(data: IChangeRequestDescriptionSchema): Observable<any> {
        return this.http.post(this.apiURL() + '/api/requests/edit-description', data, this.headers())
            .pipe(
                catchError(this.handleError)
            );
    }

    /** Assuntos que podem ser solicitados, com órgão, prazo e documentos obrigatórios. */
    public listServiceCatalog(): Observable<IServiceCatalogResponse> {
        return this.http.get<IServiceCatalogResponse>(this.apiURL() + '/api/requests/catalog', this.headers());
    }

    /** Totais por situação e correções pendentes do cidadão logado. */
    public getCitizenOverview(): Observable<ICitizenOverview> {
        return this.http.get<ICitizenOverview>(this.apiURL() + '/api/requests/citizen-overview', this.headers());
    }

    public updateSubject(requestId: number, SOL_CodigoAssunto: number): Observable<any> {
        return this.http.post(this.apiURL() + '/api/requests/update-subject', { requestId, SOL_CodigoAssunto }, this.headers());
    }

    public saveDocumentRequest(data) {
        return this.http.post(this.apiURL() + '/api/requests/documents', data, this.headers())
        .pipe(
            catchError(this.handleError)
        );
    }

    public signDocumentRequest(code: string, base64: string) {
        const data = {
            code,
            base64
        }
        return this.http.post(this.apiURL() + '/api/requests/documents-enveloped', data, this.headers())
        .pipe(
            catchError(this.handleError)
        );
    }

    public getScreeningProcess() {
        return this.http.get(this.apiURL() + '/api/requests/get-screening-process/', this.headers());
    }

    public mergedDocumentInPdf(files: ISendFileProcessPdf[], requestId: number, requestNumber: string, org: string) {
        const formData = new FormData();
        for (const fileElement of files) {
            formData.append(fileElement.name, fileElement.file, fileElement.name + '.pdf');
        }
    
        return this.http.post(
            this.apiURL() + '/api/pdf/request/' + requestId + '/' + requestNumber + '/' + org,
            formData,
            {
                ...this.headers(true),
                responseType: 'blob',
                reportProgress: true,
                observe: 'events'
            }
        );
    }

    public generateListReportPDF(title: string, condition: string) {
        const formData = new FormData();
        formData.append('title', title);
        formData.append('condition', condition);

        return this.http.post(
            this.apiURL() + '/api/pdf/request-report-list', 
            formData, 
            { 
                ...this.headers(true), 
                responseType: 'blob', 
                reportProgress: true, 
                observe: 'events' 
            }
        );
    }
}
